const colors = {
  mainCoral: '#f15846',
  subCoral: '#ff6553',
  lightCoral: '#F8ABA2',
  yellow: '#F2C94C',
  black: '#292929',
  white: '#fff',
  white50: '#ffffff7f',
  gray50: '#f2f2f2',
  gray100: '#dbdbdb',
  gray200: '#8b8987',
  gray300: '#767676',
  gray400: '#494949',
};

const fontSize = {
  xs: '1.2rem',
  sm: '1.4rem',
  base: '1.6rem',
  md: '1.8rem',
  lg: '2.4rem',
};

const theme = {
  colors,
  fontSize,
};

export default theme;
